// extracted by mini-css-extract-plugin
module.exports = {"box":"MarketingTeaserBox_box__PalqI"};